
export const url = 'https://uat.api-vulnytics.isecurion.com'
